// hooks/useGlobalFocusVisible.ts
import { useConfigStore } from '@/stores';
import { useEffect } from 'react';
import { inputMethodTracker } from '@/lib/input-method-tracker';

export function useFocusVisible() {
    const voice = useConfigStore((state) => state?.config?.tts?.voice);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const navigationKeys = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter'];
            const key = navigationKeys.includes(e.key) ? (e.key as 'Tab' | 'ArrowUp' | 'ArrowDown' | 'ArrowLeft' | 'ArrowRight' | 'Enter') : 'Other';

            // Track keyboard input
            inputMethodTracker.setMethod('keyboard', key);

            // Set data-focus-visible based on logic
            if (navigationKeys.includes(e.key) && !voice) {
                document.body.setAttribute('data-focus-visible', 'true');
            }
        };

        const handleMouseDown = () => {
            // Track mouse input
            inputMethodTracker.setMethod('mouse');

            if (!voice) {
                document.body.setAttribute('data-focus-visible', 'none');
            }
        };

        if (voice) {
            document.body.setAttribute('data-focus-visible', 'false');
        }

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('mousedown', handleMouseDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('mousedown', handleMouseDown);
        };
    }, [voice]);
}
